import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, MapPinIcon } from 'lucide-react';
import { navLinks, profile } from '../data/site';
export function Footer() {
  return <footer className="w-full bg-ink-950 py-12 text-ivory" data-id="element-44" data-mp="32o4deh7i4k9p">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-6 lg:flex-row lg:items-center lg:justify-between lg:px-10" data-id="element-45" data-mp="32pp601a99t4x">
        <div data-id="element-46" data-mp="3uf0phflqmkvx">
          <p className="font-display text-base" data-id="element-47" data-mp="3ufa64ckw7foy">{profile.name}</p>
          <p className="mt-2 text-[13px] text-slate-300" data-id="element-48" data-mp="3ucxndx7b91au">{profile.title}</p>
        </div>

        <nav aria-label="Footer" className="flex flex-wrap gap-x-6 gap-y-3" data-id="element-49" data-mp="37xwqjq946jl">
          {navLinks.map(link => <Link key={link.to} to={link.to} className="text-[13px] text-slate-300 transition-colors hover:text-brass-300" data-id="element-50" data-mp="3lgooqkr5q6pr">
              {link.label}
            </Link>)}
        </nav>

        <div className="flex items-center gap-4" data-id="element-51" data-mp="2ezbag0sgpc5l">
          <span className="inline-flex items-center gap-2 border border-white/15 px-3 py-2 text-[12px] text-slate-200" data-id="element-52" data-mp="2evxat0b6nh1u">
            <MapPinIcon size={13} className="text-brass-400" data-id="element-53" data-mp="3gapfjptkcwj5" />
            MSP · SF
          </span>
          <a href={profile.linkedin} target="_blank" rel="noreferrer noopener" aria-label="LinkedIn profile" className="flex h-9 w-9 items-center justify-center border border-white/15 text-slate-200 transition-colors hover:border-brass-400 hover:text-brass-300" data-id="element-54" data-mp="3v7gbtq7xxs4j">
            <LinkedinIcon size={16} data-id="element-55" data-mp="335u5kj2dpi2" />
          </a>
        </div>
      </div>

      <div className="mx-auto mt-10 max-w-7xl px-6 lg:px-10" data-id="element-56" data-mp="ht39daz0n4v4">
        <p className="border-t border-white/10 pt-6 text-[12px] text-slate-400" data-id="element-57" data-mp="huo4b1p8spti">
          © {new Date().getFullYear()} {profile.name}. All rights reserved.
        </p>
      </div>
    </footer>;
}